<template>
    <div>
        <InternetExplorerWarning v-if="isInternetExplorer"/>

        <template v-else>
            <cookie-popup></cookie-popup>

            <!-- To preload material icons for offline mode -->
            <i class="material-icons" style="position: absolute;pointer-events:none;visibility:hidden;">home</i>

            <div class="poll-filling-offline-bar" v-show="!isOnline">
                <div class="poll-filling-preview-bar">
                    <span class="place-for-loading">{{ 'poll_filling.internet_interrupted' | lang }}</span>
                    <i class="material-icons circle-btn-loading">&#xE863;</i>
                </div>

                <template v-if="offlineTime > 3">
                    <div class="poll-filling-preview-bar">
                        <span>{{ 'poll_filling.internet_please_dont_reload' | lang }}</span>
                    </div>
                    <div v-if="unsavedData.length" class="poll-filling-preview-bar">
                        <span>{{ 'poll_filling.unsent_answer_count' | lang }}: {{ unsavedData.length }}</span>
                    </div>
                </template>
            </div>

            <div class="poll-filling-offline-bar" v-show="cameOnline || offlineAnswersSent">
                <div class="poll-filling-preview-bar success-block" v-if="cameOnline">
                    <span class="place-for-loading">{{ 'poll_filling.internet_restored' | lang }}</span>
                    <i class="material-icons">&#xE86C;</i>
                </div>
                <div class="poll-filling-preview-bar success-block" v-if="offlineAnswersSent">
                    <span class="place-for-loading">{{ 'poll_filling.offline_answers_sent' | lang }}</span>
                    <i class="material-icons">&#xE86C;</i>
                </div>
            </div>

            <div class="poll-filling-preview-bar" v-if="is_preview">
                <strong>{{ 'poll_filling.you_are_in_preview' | lang }}</strong>
                <span>{{ 'poll_filling.your_answer_wont_be_saved' | lang }}</span>
            </div>

            <template v-if="preloading">

                <!-- Loader. -->
                <div id="poll-filling-preloading">
                    <img v-if="branding.loading.image" :src="branding.loading.image" alt="loading"/>
                    <div v-else class="preloader-wrapper small active">
                        <div class="spinner-layer spinner-white-only">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="gap-patch">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    <strong>{{ 'general.loading' | lang }}</strong>
                </div>
            </template>

            <template v-else>
                <became-indicator></became-indicator>

                <div v-if="previewUser === true" class="alert alert-danger" style="text-align: center">
                    <b>You are in preview mode!</b>
                    Your answers will not be saved here!
                </div>

                <template v-if="error.msg">

                    <!-- Error block. -->
                    <div class="poll-wrapper" key="error">
                        <div class="poll-full">
                            <div class="poll-header-title">
                                <strong style="margin-bottom: 24px;">{{ error.msg }}</strong>
                            </div>
                            <img v-bind:src="branding.icon.welcome" alt=""/>
                            <div class="poll-text-block" v-if="poll_info.welcome">
                                <p v-if="error.show_id">Poll id: {{ poll_id }}</p>
                            </div>
                        </div>
                    </div>
                </template>

                <template v-else>

                    <!-- The content. -->
                    <div class="poll-wrapper" v-if="poll_info.welcome" key="welcome">

                        <div class="poll-filling-edit-panel" v-if="textEditor.enabled">
                            <i class="material-icons">&#xE22B;</i>
                            <div v-if="textEditor.active">
                                <div><strong><span>{{ 'components/poll.editting-on' | lang }}</span>
                                    {{ 'components/poll.click-on-texts' | lang }}</strong></div>
                                <div>
                                    <button class="btn-red" @click="textEditorCancel()">
                                        {{ 'components/poll.editting-cancel' | lang }}
                                    </button>
                                    <button @click="textEditorSave()">{{
                                            'components/poll.editting-save' | lang
                                        }}
                                    </button>
                                </div>
                            </div>
                            <div v-else>
                                <button @click="textEditor.active = true">{{
                                        'components/poll.edit-survey-texts' | lang
                                    }}
                                </button>
                            </div>
                        </div>

                        <div class="poll-full">
                            <div class="poll-header-title">
                                <strong style="margin-bottom: 24px;" v-html="poll_info.title"></strong>

                                <template v-if="type == 'subjects'">
                                    <span v-if="poll_info.school">{{ poll_info.school }}</span> <strong>
                                    <template v-if="poll_info.class">{{ poll_info.class }} -</template>
                                    {{ poll_info.teacher }}</strong>
                                    <a
                                        v-if="getNextPoll()"
                                        class="not-in-class-info"
                                        :href="`/student/poll/${getNextPoll()}/0`"
                                    >
                                        {{ 'components/poll.not-in-class' | lang }}
                                    </a>
                                </template>

                                <template v-if="type == 'school'">
                                    <span>{{ poll_info.school }}</span> <strong>{{ poll_info.class }}</strong>
                                </template>

                                <template v-if="type == 'teacher'">
                                    <strong>{{ poll_info.school }}</strong>
                                </template>

                                <template v-if="type == 'parent'">

                                    <template v-if="poll_info.account == 'solo'">
                                        <span v-if="poll_info.teacher">{{ poll_info.teacher }}</span>
                                        <strong v-if="poll_info.group">{{ poll_info.group }}</strong>
                                    </template>

                                    <template v-if="poll_info.account == 'school'">
                                        <span v-if="poll_info.school">{{ poll_info.school }}</span>
                                        <strong v-if="poll_info.class">{{ poll_info.class }}</strong>
                                    </template>
                                </template>
                            </div>

                            <img v-bind:src="branding.icon.welcome" alt=""/>
                            <div
                                class="poll-text-block"
                                v-if="poll_info.welcome || (poll_info.welcome_msg != '' && textEditor.active)"
                            >
                                <template v-if="textEditor.active">
                                    <text-editor
                                        :init_value="poll_info.welcome_msg"
                                        :field_key="'poll_info.welcome_msg'"
                                        :model.sync="textEditor.text"
                                    ></text-editor>
                                </template>
                                <p v-else v-html="poll_info.welcome_msg"></p>
                            </div>

                            <select
                                v-if="languages.show"
                                v-on:change="change_poll_language()"
                                v-model="currentPollLanguage"
                                class="ed-selecter"
                                data-edselect-config="{ 'searchable': false }"
                            >
                                <option
                                    v-for="survey_language in languages.list"
                                    :selected="language === survey_language.code"
                                    :value="survey_language.code"
                                >{{ survey_language.name }}</option>
                            </select>

                            <div class="poll-start-survey">
                                <button
                                    @click="start_survey()"
                                    v-bind:disabled="this.textEditor.enabled && this.textEditor.active"
                                    :class="['start-survey-btn', { 'is-starting-survey': isStartingSurvey }]"
                                >
                                    <div class="starting-survey-icon"><i class="material-icons loading">autorenew</i></div>
                                    <span>{{ 'components/poll.button-start' | lang }}</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="poll-wrapper" v-if="!onboarding.finished && !poll_info.welcome" key="onboarding">
                        <div class="poll-full poll-onboarding">

                            <div class="slide-wrapper">
                                <template v-for="(item, index) in onboarding.list">
                                    <div
                                        class="slide"
                                        v-bind:style="{ marginLeft: (onboarding.active > 0 && index == 0)?(-(onboarding.active*onboarding.width))+'px':'0' }"
                                    >
                                        <img v-bind:src="item.img" alt=""/>
                                        <div class="poll-text-block">
                                            <h3>{{ item.title }}</h3>
                                            <p>{{ item.desc }}</p>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <div class="poll-onboarding-navi">
                                <button class="left" v-if="onboarding.active > 0" @click="onboarding.active--">
                                    <i class="material-icons">&#xE5CB;</i></button>
                                <button class="right" @click="onboarding_next()"><i class="material-icons">&#xE315;</i>
                                </button>
                                <span>
                    					<button
                                            v-for="(item, index) in onboarding.list"
                                            v-bind:class="{'active': index == onboarding.active}"
                                            @click="onboarding.active = index"
                                        >&nbsp;</button>
                    				</span>
                            </div>

                        </div>
                    </div>

                    <div
                        class="poll-wrapper poll-actual-questions"
                        v-show="onboarding.finished && !poll_info.welcome && current_page <= total_pages"
                    >

                        <div class="poll-filling-edit-panel" v-if="textEditor.enabled">
                            <i class="material-icons">&#xE22B;</i>
                            <div v-if="textEditor.active">
                                <div><strong><span>{{ 'components/poll.editting-on' | lang }}</span>
                                    {{ 'components/poll.click-on-texts' | lang }}</strong></div>
                                <div>
                                    <button class="btn-red" @click="textEditorCancel()">
                                        {{ 'components/poll.editting-cancel' | lang }}
                                    </button>
                                    <button @click="textEditorSave()">{{
                                            'components/poll.editting-save' | lang
                                        }}
                                    </button>
                                </div>
                            </div>
                            <div v-else>
                                <button @click="textEditor.active = true">{{
                                        'components/poll.edit-survey-texts' | lang
                                    }}
                                </button>
                            </div>
                        </div>

                        <div class="poll-header" v-else>
                            <div class="poll-header-logo">
                                <a href="#"><img v-bind:src="branding.icon.head" alt="Edurio"/></a>
                            </div>
                            <div class="poll-header-title">
                                <template v-if="type == 'subjects'">
                                    <span v-if="poll_info.school">{{ poll_info.school }}</span> <strong>
                                    <template v-if="poll_info.class">{{ poll_info.class }} -</template>
                                    {{ poll_info.teacher }}</strong>
                                </template>

                                <template v-if="type == 'school'">
                                    <span>{{ poll_info.school }}</span> <strong>{{ poll_info.class }}</strong>
                                </template>

                                <template v-if="type == 'teacher'">
                                    <strong>{{ poll_info.school }}</strong>
                                </template>

                                <template v-if="type == 'parent'">

                                    <template v-if="poll_info.account == 'solo'">
                                        <span v-if="poll_info.teacher">{{ poll_info.teacher }}</span>
                                        <strong v-if="poll_info.group">{{ poll_info.group }}</strong>
                                    </template>

                                    <template v-if="poll_info.account == 'school'">
                                        <span v-if="poll_info.school">{{ poll_info.school }}</span>
                                        <strong v-if="poll_info.class">{{ poll_info.class }}</strong>
                                    </template>
                                </template>

                                <div
                                    v-if="is_authenticated"
                                    class="poll-header-title-btn"
                                    v-bind:class="{ 'active': help_tooltip == -1 }"
                                >
                                    <i class="material-icons" @click="clickHelpTooltip(-1)">&#xE5D2;</i>
                                    <ul>
                                        <li><a href="/dashboard">{{ 'main.dashboard' | lang }}</a></li>
                                        <li><a href="/logout">{{ 'main.logout' | lang }}</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <template v-if="loading">
                            <div class="poll-container">
                                <div class="poll-loading-container">
                                    <img src="/material/img/edurio-loading.gif" alt=""/>
                                    <strong>{{ 'general.loading' | lang }}</strong>
                                </div>
                            </div>
                        </template>

                        <template v-else>
                            <div
                                class="poll-container"
                                v-for="(question, index) in questions"
                                v-bind:class="{ 'poll-container-focused': (index == 0 && question.question_type !== 'header_question') || (index == 1 && questions[0].question_type == 'header_question'), 'can-focus-me': question.question_type !== 'header_question' && question.question_type !== '' }"
                                :key="question.id"
                                :data-question-id="question.id"
                                :data-response-id="responseId"
                                :data-target-id="poll_id"
                            >

                                <ErrorPopup
                                    v-if="!answerSavingSuccessful"
                                    :is-static="true"
                                    :errorMessage="$options.filters.lang('poll_filling.failed-to-save-answer')"
                                />

                                <div v-if="question.hidden == false">
                                    <div class="poll-question"
                                        v-bind:class="[question.question_type, { 'title': question.question_type === 'header_question' }]">
                                        <div
                                            class="help-box"
                                            v-bind:class="{ 'active': help_tooltip == index, 'can-be-editted': textEditor.active }"
                                            v-if="question.help && question.help != '' || textEditor.active"
                                        >
                                            <i class="material-icons" @click="clickHelpTooltip(index)">&#xE887;</i>
                                            <template v-if="textEditor.active">
                                                <text-editor
                                                    :init_value="question.help"
                                                    :field_key="'database.questions['+(current_page-1)+']['+index+'].help'"
                                                    :model.sync="textEditor.text"
                                                ></text-editor>
                                            </template>
                                            <div v-else>
                                                <p v-html="question.help"></p>
                                            </div>
                                        </div>
                                        <strong>
                                            <span v-if="question.question_type !== 'header_question'">{{ questionIndex(current_page - 1, index) }}</span>
                                            <template v-if="textEditor.active">
                                                <text-editor
                                                    :model.sync="textEditor.text"
                                                    :init_value="question.question"
                                                    :field_key="'database.questions['+(current_page-1)+']['+index+'].question'"
                                                ></text-editor>
                                            </template>
                                            <font v-else v-html="question.question"></font>
                                            <span
                                                class="check-multiple-answers"
                                                v-if="question.question_type == 'multichoice_checkbox'"
                                            >{{ 'poll_filling.you_can_select_more_than_one_ans' | lang }}</span>
                                        </strong>
                                    </div>
                                    <div class="poll-answers" v-if="question.question_type !== 'header_question'">

                                        <template v-if="question.question_type == 'open' && question.display_type != 'numerals'">
                                            <p
                                                class="poll-filling-explain-error"
                                                v-bind:class="{'hide': isCorrectCharCnt(question)}"
                                            >{{ 'poll_filling.open_question_error_char_limit' | lang }}</p>
                                            <div class="answer-type-open-answer">
                                                <label>
                                                    <textarea
                                                        v-bind:class="{'poll-filling-input-error': !isCorrectCharCnt(question)}"
                                                        data-autoresize
                                                        rows="2"
                                                        :placeholder="$options.filters.lang('poll_filling.write_answer_here')"
                                                        v-model="question.answer"
                                                    ></textarea>
                                                    <span
                                                        v-if="question.meta && question.meta.char_limit"
                                                        class="char-limit"
                                                    >
                      												<!-- Left in case if later is needed. Remove if today is pass 1st Jan 2018.
                      												<span v-if="question.meta.char_limit.min" class="char-limit-min">
                      													<span class="char-limit-label">{{ 'poll_filling.min_char' | lang }}:</span><span class="char-limit-value">{{question.meta.char_limit.min}}</span>
                      												</span>
                      												<span v-if="question.meta.char_limit.max" class="char-limit-max">
                      													<span class="char-limit-label">{{ 'poll_filling.max_char' | lang }}:</span><span class="char-limit-value">{{question.meta.char_limit.max}}</span>
                      												</span>
                      												-->
                      												<span
                                                                        v-if="question.meta.char_limit.max"
                                                                        class="char-limit-chars-left"
                                                                    >
                      													<span class="char-limit-value">{{ getCharactersLeft(question) }}</span>
                      												</span>
                      											</span>
                                                </label>
                                            </div>
                                        </template>

                                        <template v-if="question.question_type == 'open' && question.display_type == 'numerals'">
                                            <p
                                                v-if="displayNumeralAnswerError[question.id]"
                                                class="poll-filling-explain-error"
                                            >{{ 'poll_filling.open_question_error_numbers' | lang }}</p>
                                            <p
                                                class="poll-filling-explain-error"
                                                v-bind:class="{'hide': isCorrectCharCnt(question)}"
                                            >{{ 'poll_filling.open_question_error_char_limit' | lang }}</p>
                                            <div class="answer-type-open-answer">
                                                <label>
                                                    <textarea
                                                        :data-check-numerals="checkValidNumerals(question)"
                                                        :class="{ 'poll-filling-input-error': displayNumeralAnswerError[question.id] }"
                                                        data-autoresize rows="2"
                                                        :placeholder="$options.filters.lang('poll_filling.write_answer_here')"
                                                        v-model="question.answer"
                                                        @keyup="checkValidNumerals(question)"
                                                    ></textarea>
                                                </label>
                                                <span
                                                    v-if="question.meta && question.meta.char_limit"
                                                    class="char-limit"
                                                >
                    											<span
                                                                    v-if="question.meta.char_limit.max"
                                                                    class="char-limit-chars-left"
                                                                >
                    												<span class="char-limit-value">{{ getCharactersLeft(question) }}</span>
                    											</span>
                    										</span>
                                            </div>
                                        </template>

                                        <template v-if="question.question_type == 'slider'">
                                            <div
                                                class="answer-type-slider"
                                                :key="'range-slider-' + current_page + '-' + questionIndex(current_page-1, index)"
                                            >
                                                <label>
                                                    <range-slider
                                                        :value.sync="question.answer"
                                                        :question.sync="question"
                                                        :min="1"
                                                        :max="question.options.length"
                                                        :step="1"
                                                        :first="question.options[0]['name']"
                                                        :last="question.options[question.options.length - 1]['name']"
                                                        :text-edit-pointer="'database.questions['+(current_page-1)+']['+index+'].options'"
                                                        :text-editor="textEditor"
                                                        :text-edit="textEdit"
                                                        @changed="(value) => {question.answer = value}"
                                                    ></range-slider>
                                                </label>
                                            </div>
                                        </template>

                                        <template v-if="question.question_type == 'multichoice_radio'">
                                            <template v-if="question.display_type == 'slider'">
                                                <div
                                                    class="answer-type-slider"
                                                    :key="'range-slider-' + current_page + '-' + questionIndex(current_page-1, index)"
                                                >
                                                    <label>
                                                        <radio-slider
                                                            :answer.sync="question.answer"
                                                            :question.sync="question"
                                                            :min="1"
                                                            :max="question.options.length"
                                                            :step="1"
                                                            :first="question.options[0]['name']"
                                                            :last="question.options[question.options.length - 1]['name']"
                                                            :text-edit-pointer="'database.questions['+(current_page-1)+']['+index+'].options'"
                                                            :text-editor="textEditor"
                                                            :text-edit="textEdit"
                                                            @changed="(value) => {question.answer = value}"
                                                        ></radio-slider>
                                                    </label>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <template v-if="question.display_type == 'dropdown'">
                                                    <div class="answer-type-dropdown">
                                                        <select
                                                            class="ed-selecter"
                                                            :data-edselect-config="'{ \'searchable\': true, \'placeholder\': \'' + $options.filters.lang('poll_filling.dropdown_choose_one') + '\' }'"
                                                            v-model="questions[index].answer"
                                                        >
                                                            <option
                                                                v-for="(item, ind) in question.options"
                                                                v-bind:value="item.value"
                                                            >{{ item['name'] }}</option>
                                                        </select>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="answer-type-multiple-choise">
                                                        <div
                                                            class="label-placeholder"
                                                            v-for="(item, ind) in question.options"
                                                            @click="textareaBlur($event, true)"
                                                        >
                                                            <template>
                                                                <label v-if="textEditor.active">
                                                                    <text-editor
                                                                        :init_value="item.name"
                                                                        :field_key="'database.questions['+(current_page-1)+']['+index+'].options['+ind+'].name'"
                                                                        :model.sync="textEditor.text"
                                                                    ></text-editor>
                                                                </label>
                                                                <template v-else>
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            v-bind:name="'all_radios_'+index"
                                                                            @change="multiRadioChange(index, item)"
                                                                            v-bind:checked="ifChoiseChecked(index, item)"
                                                                        />
                                                                        <span
                                                                            v-bind:data-key-icon="item.can_comment ? '' : ''"
                                                                            v-bind:data-key-opt="keyOptions[ind]"
                                                                            v-bind:data-key-opt-2="keyOptions[getLastQuestionOptions(questions, index) + ind]"
                                                                        ><span v-html="item.name"></span></span>
                                                                    </label>
                                                                    <textarea
                                                                        v-bind:class="[ifChoiseChecked(index, item) ? 'comment-answer' : 'hidden', 'nw-key-opt-' + keyOptions[ind]]"
                                                                        v-model="item.comment"
                                                                        @focus="textareaFocus($event)"
                                                                        @blur="setOptionsComment(index, item);textareaBlur($event)"
                                                                        v-if="item.can_comment"
                                                                        :name="'comment_' + index"
                                                                        :placeholder="$options.filters.lang('components/poll.button-comment')"
                                                                    ></textarea>
                                                                </template>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                        </template>

                                        <template v-if="question.question_type == 'multichoice_checkbox'">
                                            <div class="answer-type-multiple-choise">
                                                <!-- {{ question }} -->

                                                <span
                                                    v-if="question.meta && question.meta.char_limit"
                                                    class="alert alert-danger"
                                                    style="font-size: 13px; padding: 8px 20px;"
                                                >
                                          <span v-if="question.meta.char_limit.min" class="char-limit-min">
                                            <span class="char-limit-label">{{
                                                    'poll_filling.min_option_count' | lang
                                                }}:</span><span class="char-limit-value">{{ question.meta.char_limit.min }}</span>
                                          </span>
                                          <span v-if="question.meta.char_limit.max" class="char-limit-max">
                                            <span class="char-limit-label">{{
                                                    'poll_filling.max_option_count' | lang
                                                }}:</span><span class="char-limit-value">{{ question.meta.char_limit.max }}</span>
                                          </span>
                                        </span>
                                                <div
                                                    class="label-placeholder"
                                                    v-for="(item, ind) in question.options"
                                                    @click="textareaBlur($event, true)"
                                                >
                                                    <template>
                                                        <label v-if="textEditor.active">
                                                            <text-editor
                                                                :init_value="item.name"
                                                                :field_key="'database.questions['+(current_page-1)+']['+index+'].options['+ind+'].name'"
                                                                :model.sync="textEditor.text"
                                                            ></text-editor>
                                                        </label>
                                                        <template v-else>
                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    @change="multiCheckboxChange(index, item)"
                                                                    v-bind:checked="ifChoiseChecked(index, item)"
                                                                />
                                                                <span
                                                                    v-bind:data-key-icon="item.can_comment ? '' : ''"
                                                                    v-bind:data-key-opt="keyOptions[ind]"
                                                                    v-bind:data-key-opt-2="keyOptions[getLastQuestionOptions(questions, index) + ind]"
                                                                ><span v-html="item.name"></span></span>
                                                            </label>
                                                            <textarea
                                                                v-bind:class="[ifChoiseChecked(index, item) ? 'comment-answer' : 'hidden', 'nw-key-opt-' + keyOptions[ind]]"
                                                                v-model="item.comment"
                                                                @focus="textareaFocus($event)"
                                                                @blur="setOptionsComment(index, item);textareaBlur($event)"
                                                                v-if="item.can_comment"
                                                                :name="'comment_' + index"
                                                                :placeholder="$options.filters.lang('components/poll.button-comment')"
                                                            ></textarea>
                                                        </template>
                                                    </template>
                                                </div>
                                            </div>
                                        </template>

                                    </div>
                                    <div class="poll-comment" v-if="question.can_comment">
                                        <a
                                            href="javascript:void(0);"
                                            @click="clickToComment(index)"
                                            v-show="comment_open != index && !question.comment || comment_open < 0 && question.comment.length >= 0"
                                        ><i class="material-icons">&#xE625;</i><span>{{
                                                'poll_filling.explain_your_choice' | lang
                                            }}</span></a>
                                        <div
                                            class="poll-comment-form"
                                            v-show="!(comment_open != index && !question.comment || comment_open < 0 && question.comment.length >= 0)"
                                        >
                                            <p
                                                v-if="questionHasCommentButNoAnswer(question)"
                                                class="poll-filling-explain-error"
                                            >{{ 'poll_filling.provide_answer_to_comment' | lang }}</p>

                                            <p
                                                v-if="checkIfMoreThanLimit({ comment: question.comment })"
                                                class="poll-filling-explain-error"
                                            >{{ 'poll_filling.open_question_error_char_limit' | lang }}</p>

                                            <label> <i class="material-icons">&#xE625;</i>
                                                <textarea
                                                    autofocus="autofocus"
                                                    :class="[`comment-textarea-nr-${index}`, {
                                                        'poll-filling-input-error':
                                                            questionHasCommentButNoAnswer(question) ||
                                                            checkIfMoreThanLimit({ comment: question.comment })
                                                    }]"
                                                    data-autoresize
                                                    rows="1"
                                                    :placeholder="$options.filters.lang('components/poll.button-comment')"
                                                    v-model="question.comment"
                                                ></textarea>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </template>
                    </div>

                    <div
                        class="poll-footer"
                        v-if="onboarding.finished && !poll_info.welcome && current_page <= total_pages && total_pages > 0"
                    >
                        <div class="poll-footer-info-message" v-bind:class="{'active': pollFooterMsg}">
                            <p>{{ 'poll_filling.you_can_select_more_than_one_ans' | lang }}</p>
                        </div>
                        <div
                            class="poll-footer-info-message"
                            v-bind:class="{'active': typeof warning['minimal_requirement'] !== 'undefined'}"
                        >
                            <p
                                v-if="typeof warning['minimal_requirement'] !== 'undefined'"
                                style="background: #FF6527; color: #fff;"
                            >
                                {{ 'poll_filling.min_answer_count' | lang }}: {{
                                    warning['minimal_requirement']['need']
                                }}<br/>
                                {{ 'poll_filling.min_you_have' | lang }}: {{ warning['minimal_requirement']['has'] }}
                            </p>
                        </div>
                        <div
                            class="poll-footer-info-message"
                            v-bind:class="{'active': typeof warning['maximum_allowed'] !== 'undefined'}"
                        >
                            <p
                                v-if="typeof warning['maximum_allowed'] !== 'undefined'"
                                style="background: #FF6527; color: #fff;"
                            >
                                {{ 'poll_filling.max_answer_count' | lang }}: {{
                                    warning['maximum_allowed']['allowed']
                                }}<br/>
                                {{ 'poll_filling.max_you_have' | lang }}: {{ warning['maximum_allowed']['has'] }}
                            </p>
                        </div>

                        <div class="poll-wrapper">
                            <div class="row">
                                <div class="col s6">
                                    <div
                                        class="poll-footer-progress"
                                        v-bind:title="total_pages+' / '+current_page+' ('+Math.round(100/total_pages*(current_page-1))+'%)'"
                                    >
                                        <div v-bind:style='{ width: (100/total_pages*(current_page-1))+"%" }'></div>
                                    </div>
                                    <p class="poll-footer-progress-text"><span
                                        :class="'pr-sl-'+current_page"
                                        v-html="Math.round(100/total_pages*(current_page-1)) + '%'"
                                    ></span> {{ 'poll_filling.completed' | lang }}</p>
                                </div>
                                <div class="col s6">
                                    <div class="row">
                                        <div class="col s6">
                                            <button
                                                class="btn btn-full btn-previous nw-survey-filing-back-link"
                                                v-bind:disabled="this.textEditor.enabled && this.textEditor.active"
                                                @click="load_prev_question()"
                                            >
                                                <i class="material-icons">&#xE5CB;</i>{{ 'poll_filling.back' | lang }}
                                            </button>
                                        </div>
                                        <div class="col s6">
                                            <button
                                                class="btn btn-full nw-survey-filing-next-link"
                                                :disabled="loading || inTransition || displayRetrying"
                                                :class="{
                                                    'disabled': loading || is_disabled_next() && getFirstInvalidQuestion() == false,
                                                    'btn-previous': getFirstInvalidQuestion()
                                                }"
                                                @click="load_next_question()"
                                                style="pointer-events: all;"
                                            >
                                                <template v-if="displayRetrying">
                                                    <span class="retry-countdown">{{
                                                            nextQuestionRetryCountdown
                                                        }}</span>
                                                </template>
                                                <template v-else-if="current_page >= total_pages">
                                                    <i class="material-icons btn-finish">done</i>
                                                    <span>{{ 'poll_filling.finish' | lang }}</span>
                                                </template>
                                                <template v-else>
                                                    <span v-html="$options.filters.lang('poll_filling.next')"></span>
                                                    <i
                                                        class="material-icons"
                                                        v-if="getFirstInvalidQuestion()"
                                                    >&#xE313;</i>
                                                    <i class="material-icons" v-else>&#xE5CC;</i>
                                                </template>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="modal-mask"
                        id="poll-filling-ending-modal"
                        v-if="finishModal"
                        @click="denyToFinishPoll()"
                    >
                        <div class="modal-wrapper">
                            <div class="modal-container" @click.stop>
                                <div class="modal-body">
                                    <h4>{{ 'poll_filling.question_finish_poll' | lang }}</h4>
                                    <p>{{ 'poll_filling.info_finish_poll' | lang }}</p>
                                    <p v-show="!isOnline">{{ 'poll_filling.info_about_online' | lang }}</p>
                                </div>
                                <div class="modal-footer">
                                    <button
                                        v-if="!approveToFinish"
                                        class="modal-cancel-button"
                                        @click="denyToFinishPoll()"
                                    ><i class="material-icons">&#xE5CD;</i>{{ 'poll_filling.cancel' | lang }}
                                    </button>
                                    <button
                                        class="modal-default-button"
                                        :class="{disabled: (approveToFinish || !isOnline)}"
                                        @click="allowToFinishPoll()"
                                    ><i class="material-icons loading-icon">&#xE5CA;</i><i class="material-icons">&#xE5CA;</i>{{
                                            'poll_filling.finish' | lang
                                        }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="poll-wrapper poll-wrapper-ending"
                        v-if="onboarding.finished && !poll_info.welcome && current_page > total_pages"
                        key="ending"
                    >

                        <div class="poll-filling-edit-panel" v-if="textEditor.enabled">
                            <i class="material-icons">&#xE22B;</i>
                            <div v-if="textEditor.active">
                                <div><strong><span>{{ 'components/poll.editting-on' | lang }}</span>
                                    {{ 'components/poll.click-on-texts' | lang }}</strong></div>
                                <div>
                                    <button class="btn-red" @click="textEditorCancel()">
                                        {{ 'components/poll.editting-cancel' | lang }}
                                    </button>
                                    <button @click="textEditorSave()">{{
                                            'components/poll.editting-save' | lang
                                        }}
                                    </button>
                                </div>
                            </div>
                            <div v-else>
                                <button @click="textEditor.active = true">{{
                                        'components/poll.edit-survey-texts' | lang
                                    }}
                                </button>
                            </div>
                        </div>

                        <div v-else class="poll-header">
                            <div class="poll-header-logo">
                                <a href="#"> <img v-bind:src="branding.icon.head" alt="Edurio"/> </a>
                            </div>
                            <div class="poll-header-title">
                                <template v-if="type == 'subjects'">
                                    <span>{{ poll_info.school }}</span>
                                    <strong v-if="poll_info.class">{{ poll_info.class }} -
                                        {{ poll_info.teacher }}</strong>
                                </template>

                                <template v-if="type == 'school'">
                                    <span>{{ poll_info.school }}</span> <strong>{{ poll_info.class }}</strong>
                                </template>

                                <template v-if="type == 'parent'">
                                    <strong>{{ poll_info.school }}</strong>
                                </template>

                                <template v-if="type == 'teacher'">
                                    <strong>{{ poll_info.school }}</strong>
                                </template>

                                <template v-if="type == 'solo'">
                                    <span>{{ poll_info.teacher }}</span> <strong>{{ poll_info.group }}</strong>
                                </template>

                                <div
                                    v-if="is_authenticated"
                                    class="poll-header-title-btn"
                                    v-bind:class="{ 'active': help_tooltip == -1 }"
                                >
                                    <i class="material-icons" @click="clickHelpTooltip(-1)">&#xE5D2;</i>
                                    <ul>
                                        <li><a href="/dashboard">{{ 'main.dashboard' | lang }}</a></li>
                                        <li><a href="/logout">{{ 'main.logout' | lang }}</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="poll-full">
                            <div class="poll-header-title nw-poll-finished">
                                <strong>{{ 'components/poll.thank-you' | lang }}</strong>
                            </div>
                            <img v-bind:src="branding.icon.thank" alt=""/>
                            <div
                                class="poll-text-block"
                                v-if="poll_info.thankyou || (poll_info.thankyou_msg != '' && textEditor.active)"
                            >
                                <template v-if="textEditor.active">
                                    <text-editor
                                        :init_value="poll_info.thankyou_msg"
                                        :field_key="'poll_info.thankyou_msg'"
                                        :model.sync="textEditor.text"
                                    ></text-editor>
                                </template>
                                <p v-else v-html="poll_info.thankyou_msg"></p>
                            </div>

                            <a
                                v-if="getNextPoll() !== false"
                                class="btn btn-primary"
                                style="display: block; width: 200px; margin: 35px auto 0;"
                                :href="'/student/poll/' + getNextPoll()+'/0'"
                            >{{ 'poll_filling.outro.next' | lang }}</a>
                            <a
                                v-else
                                style="display: block; width: 200px; margin: 35px auto 0;"
                                href="/users/dashboard"
                                class="btn btn-primary"
                            >{{ 'poll_filling.outro.home' | lang }}</a>

                        </div>
                        <div class="poll-full" v-if="!pollRating.hide">
                            <div class="poll-rate-edurio" v-if="pollRating.rating !== null && pollRating.saved">
                                <span class="poll-rate-success">Your feedback has been sent</span>
                            </div>

                            <div class="poll-rate-edurio" v-if="pollRating.rating !== null && !pollRating.saved">
                                <p>Mind giving us a feedback</p>
                                <textarea
                                    data-autoresize
                                    rows="1"
                                    placeholder="Write your feedback here.."
                                    v-model="pollRating.explain"
                                    autofocus="autofocus"
                                ></textarea>
                                <button @click="pollRatingSave()" v-bind:disabled="pollRating.explain === ''">Send
                                    Feedback
                                </button>
                            </div>

                            <div class="poll-rate-edurio" v-if="pollRating.rating === null">
                                <strong>Please rate poll filling process</strong>
                                <div>
                                    <button @click="pollRatingChoose(5)"><img src="/material/img/rating/5.svg" alt=""/>
                                    </button>
                                    <button @click="pollRatingChoose(4)"><img src="/material/img/rating/4.svg" alt=""/>
                                    </button>
                                    <button @click="pollRatingChoose(3)"><img src="/material/img/rating/3.svg" alt=""/>
                                    </button>
                                    <button @click="pollRatingChoose(2)"><img src="/material/img/rating/2.svg" alt=""/>
                                    </button>
                                    <button @click="pollRatingChoose(1)"><img src="/material/img/rating/1.svg" alt=""/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="poll-powered-edurio"
                        v-bind:class="{ 'is-questions': onboarding.finished && !poll_info.welcome && current_page <= total_pages }"
                    >Powered by
                        <img
                            src="/material/img/logo-powered.png"
                            srcset="/material/img/logo-powered@2x.png 2x"
                            alt="Edurio"
                        />
                    </div>
                </template>
            </template>

            <AllModalBase/>
        </template>
    </div>
</template>

<script>
import * as VueLocale from "../../locale/VueLocale.js";
import AllModalBase from "@/components/modals/AllModalBase";
import BecameIndicator from '../../components/custom/became-indicator'
import CookiePopup from "@/components/custom/cookie-popup";
import ErrorPopup from "@/components/modals/ErrorPopup";
import InternetExplorerWarning from "../custom/InternetExplorerWarning";
import RadioSlider from '../question-type/radio-slider.vue'
import RangeSlider from '../question-type/range-slider.vue'
import SkipLogicService from '../../services/skip-logic'
import TextEditor from './text-editor.vue';
import events from '@/services/events'
import { getSurveyTemplate } from "@/services/survey-template";
import {
    openSurveyAndGetResponse,
    submitQuestions,
    getSubmitQuestionsBody,
    closeSurvey,
    getResponse,
} from "@/services/survey-response";

const CHAR_LIMIT = 10000

export default {
    components: {
        InternetExplorerWarning,
        ErrorPopup,
        CookiePopup,
        RangeSlider,
        RadioSlider,
        TextEditor,
        BecameIndicator,
        AllModalBase
    },
    props: {
        external_url: String,
        is_preview: Boolean,
        slug: String,
        session_id: String,
        group_id: Number,
        is_authenticated: {
            default: false,
        },
    },

    data() {
        return {
            isInternetExplorer: !!window.document.documentMode,
            answerSavingSuccessful: true,
            displayRetrying: false,
            nextQuestionRetryCountdown: 0,
            reloadQuestionRetries: 0,

            displayNumeralAnswerError: {},

            poll_id: this.$route.params.poll_id,
            responseId: undefined,

            currentQuestionValid: true,
            unsavedData: [],
            errorStatusCodes: [0],

            textEditor: {
                // Set 'true' to 'enabled' to allow editing
                enabled: false,
                active: false,
                text: {}
            },

            dashboard: {},

            type: '',

            branding: {
                custom: false,
                loading: {
                    image: '/material/img/edurio-loading-white.gif',
                },
                icon: {
                    welcome: '/material/img/surveys/start-survey@2x.png',
                    thank: '/material/img/surveys/start-survey@2x.png',
                    head: '/material/img/card-logo-edurio@2x.png',
                },
                bg: {
                    color: '#1db577',
                    pattern: '/material/img/texture-edurio-green.png',
                }
            },

            pollRating: {
                user: 1,
                rating: null,
                explain: '',
                saved: false,
                hide: true
            },

            database: { questions: [] },
            // Current step questions. Extracted from database.questions.
            // that.questions = that.database.questions[that.current_page-1];
            questions: [],
            skip_logic: [],
            answers: {},
            delete_questions: [],

            keyOptions: [
                'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
                'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
                '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
            ],

            help_tooltip: null,
            comment_open: null,
            onboarding: {
                active: 0,
                width: 0,
                list: [
                    {
                        title: "Help with question",
                        desc: "Usu oratio quaestio et. Case graecis ad per, cu inermis fastidii per, hinc veritus salutatus no per. Quis putent per no, at per vidisse neglegentur, mea ne aperiam inimicus signiferumque.",
                        img: "/material/img/surveys/start-survey.png"
                    },
                    {
                        title: "Help with question 2",
                        desc: "Usu oratio quaestio et 2. Case graecis ad per, cu inermis fastidii per, hinc veritus salutatus no per. Quis putent per no, at per vidisse neglegentur, mea ne aperiam inimicus signiferumque.",
                        img: "/material/img/surveys/start-survey.png"
                    },
                    {
                        title: "Help with question 3",
                        desc: "Usu oratio quaestio et 3. Case graecis ad per, cu inermis fastidii per, hinc veritus salutatus no per. Quis putent per no, at per vidisse neglegentur, mea ne aperiam inimicus signiferumque.",
                        img: "/material/img/surveys/start-survey.png"
                    }
                ],
                finished: true
            },

            error: {
                msg: '',
                show_id: true,
            },

            poll_info: {
                title: '',
                school: '',
                account: 'solo',
                class: '',
                teacher: '',
                group: '',
                welcome: true,
                welcome_msg: '',
                thankyou: false,
                thankyou_msg: '',
                survey_type: '',
            },

            survey_types: {
                parent: 'parent',
                'student-normal': 'subjects',
                'student-school': 'school',
                teacher: 'teacher',
            },

            question_types: {
                '': 'title',
                'header_question': 'title',
                "multichoice_radio": "multichoice_radio",
                "multichoice_checkbox": "multichoice_checkbox",
                "open": "open",
                "slider": "slider",
            },
            poll_progress: {
                finished: false,
                last_question_id: null,
            },
            languages: {
                show: false,
                list: {},
            },

            current_page: 0,
            total_pages: 0,

            approveToFinish: false,
            finishModal: false,
            question_was_submitted: false, // If question was already submitted prevent duplicate call.

            inTransition: false,
            loading: false,
            preloading: true,
            keyboardPreferred: false,

            stickyHeaderHeight: 0,

            previewUser: false,

            canPollFooterMsg: true,
            pollFooterMsg: false,
            outstandingRequestCount: 0, // Ongoing submit request. Wait for all question requests to be completed(or timeout) before submiting the last request.
            skipped_questions: 0,
            prev_language: 'en',
            lang_has_changed: false,

            cameOnline: false,
            isOnline: true,
            offlineTime: 0,
            offlineAnswersSent: false,
            question_start: 0,
            question_end: 0,
            external_url_id: null,
            currentPollLanguage: window.current_language,
            switchingLanguage: false,
            invalidity: {},
            warning: {},

            setLanguage: true,
            question_hash: {},
            isStartingSurvey: false,
            validationToken: undefined,
        }
    },
    mounted: function () {
        this.$watch('branding', () => {
            this.applyBranding();
        }, { deep: true });

        this.branding.custom = true;
        this.branding.loading.image = null;
        this.branding.bg.color = '#1db577';
        this.branding.bg.pattern = 'none';

        this.applyBranding();

        setInterval(() => {
            this.checkNetworkStatus();
        }, 1000);

        this.setHasLangChanged();

        // edurio/wiki#4436 for some reason, if this loads too early,
        // everything fails. Not quite sure why.
        setTimeout(() => {
            this.loadPollProperties();
        }, 1000)

        this.uiInit();

        this.get('student/dashboard').then((response) => {
            this.dashboard = response.body;
        });

    },
    methods: {
        checkIfMoreThanLimit({ answer, comment }) {
            if (answer && comment) {
                return answer && answer.length > CHAR_LIMIT || comment && comment.length > CHAR_LIMIT
            }

            if (answer) {
                return answer && answer.length > CHAR_LIMIT
            }

            if (comment) {
                return comment && comment.length > CHAR_LIMIT
            }
        },

        questionHasCommentButNoAnswer(question) {
            return (question.answer && question.answer.length === 0) && !!question.comment
        },
        async handleFailedAnswerSave() {
            events.sendPollFillingEvent('Failed saving answer', { target_id: this.poll_id })

            this.answerSavingSuccessful = false;

            const waitTillRetryMs = 5000;
            this.displayRetrying = true;
            await this.countdownToRetry(waitTillRetryMs)
            this.displayRetrying = false;
            this.nextQuestionRetryCountdown = waitTillRetryMs / 1000;
        },

        async countdownToRetry(ms, waitMs = 1000) {
            let seconds = ms / 1000;

            for (seconds; seconds > 0; seconds--) {
                this.nextQuestionRetryCountdown = seconds;
                await this.timeout(waitMs);
            }
        },

        getNextPoll() {

            if (this.dashboard.polls !== undefined) {
                for (const poll of this.dashboard.polls) {
                    if (poll.id != this.poll_id) return poll.id;
                }
            }

            return false;

        },

        applyBranding() {
            const brandingElement = document.getElementById('customcssbranding');
            if (brandingElement === null) {
                console.error('Branding element not found!');
                return;
            }

            if (this.branding.custom) {
                brandingElement.innerHTML = `body {
                    background-color: ${this.branding.bg.color};
                    background-image: ${this.branding.bg.pattern};
                }`;
            } else {
                brandingElement.innerHTML = `body {
                    background-color: #1db577;
                    background-image: url(/material/img/texture-edurio-green.png);
                }`;
            }
        },

        textareaFocus(e) {
            e.target.parentElement.classList.add('label-placeholder-focused')
            // window.scrollTo(0, (Math.abs(document.body.getBoundingClientRect().top) + e.target.getBoundingClientRect().top) - (window.innerHeight / 2));
        },

        textareaBlur(e, t) {
            if (t) {
                if (e.target) {
                    e.target.classList.remove('label-placeholder-focused')
                }
            } else {
                e.target.parentElement.classList.remove('label-placeholder-focused')
            }
            // window.scrollTo(0, (Math.abs(document.body.getBoundingClientRect().top) + e.target.getBoundingClientRect().top) - (window.innerHeight / 2));
        },

        checkNetworkStatus() {
            var wasOnilne = this.isOnline;
            this.isOnline = window.navigator.onLine;
            if (!wasOnilne && this.isOnline) {
                this.cameOnline = true;
                this.handleUnsavedData();
                setTimeout(() => {
                    this.cameOnline = false;
                }, 3000);
            }
            if (!wasOnilne && !this.isOnline) {
                this.offlineTime += 1;
            } else {
                this.offlineTime = 0;
            }
        },

        textEdit(key, e) {
            this.textEditor.text[key] = e.target.innerText;
        },

        textEditorCancel() {
            this.textEditor.text = {};
            this.textEditor.active = false;
        },

        textEditorSave() {

            //data array
            var data = {
                question: [],
                help: [],
                options: []
            };
            for (var key in this.textEditor.text) {
                let { pointers, parts } = this.getObjByPath(key);
                Vue.set(pointers[pointers.length - 1], parts[parts.length - 1], this.textEditor.text[key]);
                var type = parts[parts.length - 1];
                var parent = pointers[pointers.length - 1];

                switch (type) {
                    case 'question':
                    case 'help':
                        data[type].push({ id: parent.id, text: this.textEditor.text[key] });
                        break;
                    case 'name':
                        data['options'].push({ id: parent.value, text: this.textEditor.text[key] });
                        break;
                    case 'welcome_msg':
                        data['description_before'] = this.textEditor.text[key];
                        break;
                    case 'thankyou_msg':
                        data['description_after'] = this.textEditor.text[key];
                        break;
                }
            }

            this.$http.put('polls/' + this.poll_id + '/update_meta', data).then(function (response) {
                if (response.body.status == 0) {
                    location.reload();
                }
            });
            this.textEditor.text = {};
            this.textEditor.active = false;
        },

        // Set variable if language has been changed.
        setHasLangChanged() {

            // Language has been changed so set the prev lang.
            if (window.location.hash.indexOf('prevlang') > -1) {
                this.prev_language = window.location.hash.substr(1);
                this.lang_has_changed = true;
                window.location.hash = '';
            }
            // Language has not been changed so set the prev lang as the current.
            else {
                this.prev_language = this.language;
                this.lang_has_changed = false;
            }
        },
        getObjByPath(path) {
            // Sets new values to vue.
            // #2108 Workaround to provide Vue v.1 $set('path') functionality which allowed to set values by passing the full path.
            // In Vue 2 $set = Vue.set which requires target to be defined.
            path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
            path = path.replace(/^\./, '');           // strip a leading dot
            let parts = path.split('.');
            let pointers = [this];
            for (let i = 0; i < parts.length - 1; i++) {
                pointers.push(pointers[pointers.length - 1][parts[i]]);
            }

            return { pointers, parts };
        },
        toggleCommentBox() {
            console.log(this.prop('checked'))
        },
        getLastQuestionOptions(q, i) {
            var retVal = 0;
            if (typeof q[i - 1] !== 'undefined') {
                retVal = q[i - 1].options.length;
            }
            return retVal;
        },

        isLastPage() {
            return this.current_page >= this.total_pages;
        },

        allowToFinishPoll() {
            this.approveToFinish = true;
            this.submitPollAsFinished();
            this.current_page = Object.keys(this.database.questions).length;
        },

        denyToFinishPoll() {
            this.approveToFinish = false;
            this.finishModal = false;
            this.question_was_submitted = false;

            const lastPageQuestions = this.database.questions[this.current_page - 1];
            this.clearAndAddQuestionsToDelete(lastPageQuestions);
        },

        loadPollProperties() {

            console.log('loadPollProperties');

            // Collect survey props like teacher, class, subject.
            if (this.is_preview) {
                this.loadPollWithQuestions();
            } else if (this.poll_id > 0) {
                if (this.is_authenticated)
                    var promise = this.post('poll/' + this.poll_id + '/properties');
                else
                    var promise = this.$http.post('poll/' + this.poll_id + '/properties');

                promise.then(function (response) {
                    var data = response.data;

                    if (data.teacher && data.teacher != '') this.poll_info.teacher = data.teacher;
                    if (data.class && data.class != '') this.poll_info.group = data.class;
                    if (data.subject && data.subject != '') this.poll_info.class = data.subject;
                    if (data.school && data.school != '') this.poll_info.school = data.school;
                    if (data.account && data.account == 'school') this.poll_info.account = data.account;

                    this.loadPollWithQuestions();
                });
            } else {

                this.$http.post('poll/' + this.external_url + '/url-properties')
                    .then(function (response) {

                        var data = response.data;

                        // #955 Inform user that poll is not available.
                        if (typeof data.error !== 'undefined') {
                            this.showError(data.error, false);
                        } else {
                            this.poll_id = data.id;
                            this.external_url_id = data.id;
                            if (data.teacher && data.teacher != '') this.poll_info.teacher = data.teacher;
                            if (data.class && data.class != '') this.poll_info.group = data.class;
                            if (data.subject && data.subject != '') this.poll_info.class = data.subject;
                            if (data.school && data.school != '') this.poll_info.school = data.school;
                            if (data.account && data.account == 'school') this.poll_info.account = data.account;

                            this.loadPollWithQuestions();
                        }
                    });
            }
        },

        loadPollWithQuestions() {
            console.log('loadPollWithQuestions');
            var that = this;
            var surveyRequest;
            var surveyRequestParams = 'survey.sourcePoll,studentClass.teacher,studentClass.subject,questions.actualQuestion';

            let uri;

            if (this.is_preview && this.slug.length) {
                uri = `/preview/survey/${this.slug}`
            } else {
                if (this.external_url_id != null) {
                    this.poll_id = this.external_url_id;
                }

                uri = `/${this.is_preview ? 'preview/' : ''}${this.poll_id}`
            }

            surveyRequest = getSurveyTemplate(
                uri,
                {
                    include: surveyRequestParams,
                    external_session_id: this.session_id,
                    language: window.current_language
                }
            ).then(response => {
                that.reloadQuestionRetries = 0;
                that.database.questions = [];
                // Keep the whole poll data only in this scope so the global scope wouldn't be bloated with unnecessary data.
                let poll = response.data;

                if (poll.type === "parent") {
                    this.branding.custom = true;
                    this.branding.loading.image = null;
                    this.branding.icon.welcome = '/material/img/branding/welcome.png';
                    this.branding.icon.thank = '/material/img/branding/thank.png';
                    this.branding.icon.head = '/material/img/branding/edurio-w-h.png';
                    this.branding.bg.color = '#1db577';
                    this.branding.bg.pattern = 'none';
                } else {
                    this.branding.custom = false;
                    this.branding.loading.image = '/material/img/edurio-loading-white.gif';
                    this.branding.icon.welcome = '/material/img/surveys/start-survey@2x.png';
                    this.branding.icon.thank = '/material/img/surveys/start-survey@2x.png';
                    this.branding.icon.head = '/material/img/card-logo-edurio@2x.png';
                    this.branding.bg.color = '#1db577';
                    this.branding.bg.pattern = '/material/img/texture-edurio-green.png';
                }

                // #1268 Set poll_id if it is empty. Like in get by slug case.
                if (!this.poll_id) {
                    this.poll_id = poll.id;
                }

                //set language

                this.languages.list = poll.languages;
                this.languages.show = poll.show_language_switch;

                if (this.languages.show && this.setLanguage) {
                    this.setLanguage = false;
                    window.current_language = '';
                    this.change_poll_language(); // trigger this to set cache record
                    return;
                }

                // Check if has all required data like survey type.
                if (!this.isValidSurvey(poll)) {

                    this.showError('Invalid survey. Does not have required data like survey type.');
                    return false;
                }

                // Load the poll data.
                this.poll_info.survey_type = typeof poll.type === 'undefined' || poll.type === null ? poll.survey.data.type : poll.type;
                this.type = this.survey_types[this.poll_info.survey_type];
                if (this.type == 'parent') {
                    window.onbeforeunload = () => true
                }

                this.poll_info.title = this.getPollName(poll);

                if (typeof poll.survey !== 'undefined' && poll.survey.data !== 'undefined') {
                    // Set the welcome message.

                    if (poll.description_before != null && poll.description_before != '') {

                        this.poll_info.welcome_msg = poll.description_before;
                    } else if (poll.survey.data.description_before != null && poll.survey.data.description_before != '') {

                        this.poll_info.welcome_msg = poll.survey.data.description_before;
                    }

                    // Set the thank you message.
                    if (poll.description_after != null && poll.description_after != '') {

                        this.poll_info.thankyou = true;
                        this.poll_info.thankyou_msg = poll.description_after;
                    } else if (poll.survey.data.description_after != null && poll.survey.data.description_after != '') {

                        this.poll_info.thankyou = true;
                        this.poll_info.thankyou_msg = poll.survey.data.description_after;
                    }
                } else {
                    //if there is no survey, try to pull the welcome and thankyou text from poll
                    if (poll.description_before != null && poll.description_before != '') {

                        this.poll_info.welcome_msg = poll.description_before;
                    }

                    // Set the thank you message.
                    if (poll.description_after != null && poll.description_after != '') {

                        this.poll_info.thankyou = true;
                        this.poll_info.thankyou_msg = poll.description_after;
                    }
                }


                //Branding
                if (poll.branding != null && poll.branding.custom) {
                    this.branding.custom = true;
                    for (var icon_type in poll.branding.icon) {
                        this.branding.icon[icon_type] = poll.branding.icon[icon_type];
                        console.log('Set branding "' + icon_type + '"');
                    }
                }

                // Set up questions.
                let questions_by_groups = [];
                let question_cnt = poll.questions.data.length;
                let last_group = 0;

                this.skip_logic = poll.skip;
                this.validationToken = poll.validation;

                for (let i = 0; i < poll.questions.data.length; i++) {

                    let q = poll.questions.data[i];
                    let question = {};

                    // Require a supported question type.
                    if (!(typeof q.question_type !== 'undefined' && typeof this.question_types[q.question_type] !== 'undefined')) {

                            this.showError('Not supported question type. Question id = ' + q.id);
                            return false;
                        } else {
                            question.question_type = q.question_type;
                            question.display_type = q.display_type;
                        }

                    question.id = q.id;
                    question.question = q.question_text.replace(/{{RESOURCE#(\d+)}}/g, window.api_endpoint + '/resource/$1');

                    question.help = '';

                    if (q.description !== null && q.description.length > 0 && q.description !== 'Question description' && q.description.trim() !== '') {
                        question.help = q.description;
                    }

                    question.can_comment = q.can_comment;
                    question.is_required = q.is_required;
                    question.meta = q.meta;
                    question.hidden = false;
                    Vue.set(question, 'comment', null);
                    // question.comment = null;

                    // Set up options by the question type.
                    question.options = [];
                    question.ans_comment = {};

                    switch (question.question_type) {
                        case 'multichoice_checkbox':
                        case 'multichoice_radio':

                            if (typeof that.answers[question.id] !== 'undefined') {
                                question.answer = [];
                                if (question.question_type == 'multichoice_radio') {
                                    question.answer.push(parseInt(that.answers[question.id].answers));
                                } else {
                                    for (var a in that.answers[question.id].answers) {
                                        question.answer.push(parseInt(a));
                                    }
                                }
                            } else {
                                question.answer = null;
                            }

                            question.options = q.options.map((opt) => ({
                                value: opt.id,
                                comment: '',
                                can_comment: opt.can_comment,
                                name: opt.name,
                            }));
                            question.ans_comment = Object.fromEntries(
                                q.options.filter(o => o.can_comment).map(o => [o.id, ''])
                            );

                            break;
                        case 'title':
                        case 'header_question':

                            question.answer = null;
                            break;
                        case 'open':
                            if (typeof that.answers[question.id] !== 'undefined') {
                                question.answer = that.answers[question.id].answers;
                            } else {
                                question.answer = '';
                            }
                            break;
                        case 'slider':
                            if (typeof that.answers[question.id] !== 'undefined') {
                                question.answer = parseInt(that.answers[question.id].answers);
                            } else {
                                question.answer = 50;
                            }

                            question.options = q.options.map((opt) => ({
                                value: opt.id,
                                name: opt.name,
                            }));
                            break;
                    }
                    // Group.
                    last_group = question.group_index = q.group_index;

                    if (typeof questions_by_groups[q.group_index] === 'undefined') {

                        questions_by_groups[q.group_index] = [];
                    }

                    questions_by_groups[q.group_index].push(question);
                }

                // Questions are grouped in MULTIPLE pages.
                if (questions_by_groups.length > 1) {

                    // #363 problem is with the group_indexes and accessing the group by index (current_index - 1).
                    // Need to reset those groups with incremental keys.
                    let incremented_groups = [];

                    for (let group_index in questions_by_groups) {

                        incremented_groups.push(questions_by_groups[group_index]);
                    }

                    Vue.set(this.database, 'questions', incremented_groups);
                    this.total_pages = incremented_groups.length;
                }
                // Questions are grouped in ONE page.
                else {

                    // If this is 0 group then put them in separate pages.
                    if (last_group == 0) {

                        for (let q_index in questions_by_groups[0]) {

                            this.database.questions.push([questions_by_groups[0][q_index]]);
                        }

                        this.total_pages = questions_by_groups[0].length;
                    } else {

                        Vue.set(this.database, 'questions', questions_by_groups);
                        this.total_pages = questions_by_groups.length;
                    }
                }

                // If user tries to fill again the same survey that was not finished.
                // #1396 Do not jump to the last completed question if the language has changed.
                if (!this.is_preview && this.poll_progress.last_question_id && !this.lang_has_changed) {

                    console.log(this.poll_progress.last_question_id);

                    // Continue from the step the user left.
                    let page_left = this.getQuestionsPage(this.poll_progress.last_question_id);
                    console.log('page_left', page_left);

                    if (page_left !== null) {

                        console.log('page_left !== null');

                        this.current_page = page_left + 1;
                        this.get_current_page('start');
                        this.start_survey();
                    }
                }

                if (this.is_preview) {
                    that.textEditor.enabled = poll.can_edit == 1 ? true : false;
                }

                if (this.$store.state.user.user.extra_data === 'preview') {
                    this.previewUser = true;
                }

                // Hide the loader.
                this.preloading = false;

                if (this.poll_info.welcome && this.$route.query.start !== undefined) {
                    this.start_survey();
                }
            }).catch((response) => {
                console.error(response);
                if (response.status === 404) {
                    this.showError(this.$options.filters.lang('poll.unavailable'), false);
                    return;
                }
                this.reloadQuestions()
            });
        },

        reloadQuestions() {
            if (this.reloadQuestionRetries < 10) {
                this.reloadQuestionRetries++;
            }

            console.error(`Reloading questions after ${this.reloadQuestionRetries} seconds`)

            window.setTimeout(() => {
                this.loadPollWithQuestions();
            }, 1000 * this.reloadQuestionRetries);
        },

        isValidSurvey(poll) {

            return typeof poll !== 'undefined' && poll !== null;
        },

        showError(msg, show_id = true) {

            this.error.msg = msg;
            this.preloading = false;
            this.error.show_id = show_id;
        },

        getPollName(poll) {

            if (this.is_preview) {

                if (typeof translations['components/poll.' + poll.name] !== 'undefined') {

                    return translations['components/poll.' + poll.name];
                } else {

                    return poll.name;
                }
            } else {

                if (typeof poll.survey.data !== 'undefined' && poll.survey.data !== null) {

                    if (typeof translations['components/poll.' + poll.survey.data.name] !== 'undefined') {

                        return translations['components/poll.' + poll.survey.data.name];
                    } else {

                        return poll.survey.data.name;
                    }
                }
            }

            return '';
        },

        getQuestionsPage(question_id) {

            for (let page_index in this.database.questions) {

                let page = this.database.questions[page_index];

                for (let question_index in page) {

                    let question = page[question_index];

                    // Has found the matching question.
                    if (question.id == question_id) {

                        // Return the page number.
                        return parseInt(page_index);
                    }
                }
            }

            return null;
        },

        async start_survey() {
            this.isStartingSurvey = true;

            if (!this.is_preview && !this.previewUser) {
                let { data: surveyResponse, status } = await openSurveyAndGetResponse({
                    targetId: this.poll_id,
                    body: {
                        language: this.currentPollLanguage,
                        validation: this.validationToken
                    },
                }, this.poll_info.survey_type)
                this.responseId = surveyResponse.responseId

                await this.setProgress(surveyResponse)
                this.setCurrentPageIfHasProgress()
            }

            // Disable 'start survey' button if editor is active
            if (this.textEditor.enabled && this.textEditor.active) {
                this.isStartingSurvey = true;
                return true;
            }

            var that = this;
            this.poll_info.welcome = false;
            if (this.onboarding.finished === false) {
                this.isStartingSurvey = true;
                return false;
            }
            that.loading = true;

            setTimeout(function () {
                that.current_page += 1;
                that.get_poll_questions();
                that.isStartingSurvey = false;
            }, 400);
        },

        resetProgress() {
            this.answers = {}
            Object.values(this.database.questions).forEach((page) => {
                page.forEach((question) => {
                    question.answer = ['multichoice_checkbox', 'multichoice_radio'].includes(question.question_type) ? null : ''
                    question.comment = null
                    question.ans_comment = {};
                    question.options.forEach((option) => {
                        option.comment = null
                    });
                })
            })
        },

        async setProgress(progressResponse) {
            this.poll_progress = {
                finished: !!progressResponse.completeTime,
                last_question_id: progressResponse.lastSubmittedQuestionId
            }

            this.resetProgress()

            progressResponse.answers.forEach((answer) => {
                const pageIndex = this.getQuestionsPage(answer.questionId)
                if (pageIndex === null) return;

                const answerIndex = this.database.questions[pageIndex].findIndex((q) => q.id === answer.questionId)

                if (answerIndex !== -1) {
                    const question = this.database.questions[pageIndex][answerIndex]
                    if (question.can_comment) {
                        question.comment = answer.comment
                    }

                    switch (question.question_type) {
                        case 'multichoice_radio':
                        case 'multichoice_checkbox':
                            // eslint-disable-next-line no-case-declarations
                            const options = (answer.options || [])

                            question.answer = options.map(o => o.id)

                            this.answers[question.id] = {
                                answers: question.question_type === 'multichoice_checkbox'
                                    ? Object.fromEntries(options.map(o => [o.id, true]))
                                    : question.answer[0],
                                type: question.question_type,
                            }

                            options
                                .filter(o => o.comment)
                                .forEach(o => {
                                    const option = question.options.find((option) => option.value === o.id)
                                    if (option && option.can_comment) {
                                        option.comment = o.comment
                                        question.ans_comment[o.id] = o.comment
                                    }
                                })

                            break;
                        case 'open':
                            question.answer = answer.answerText || ''
                            this.answers[question.id] = {
                                answers: question.answer,
                                type: question.question_type,
                            }
                            break;
                    }
                }
            })
        },

        setCurrentPageIfHasProgress() {
            if (!this.poll_progress.last_question_id) return;

            const page_left = this.getQuestionsPage(this.poll_progress.last_question_id);
            console.log('page_left', page_left);

            if (page_left !== null) {
                console.log('page_left !== null');
                this.current_page = page_left + 1;
                this.get_current_page('start');
            }
        },

        change_poll_language: function () {
            if (window.current_language != this.currentPollLanguage) {
                this.prev_language = window.current_language;
                window.current_language = this.currentPollLanguage;
                sessionStorage.setItem('language', this.currentPollLanguage);

                VueLocale.loadLanguage(this.currentPollLanguage)
                if(this.external_url != ''){
                    this.poll_id = 0;
                }

                this.$http.post('poll/swap_language', {
                    current_language: window.current_language,
                    session_id: this.session_id
                }).then(response => {
                    this.switchingLanguage = true;
                    this.preloading = true;
                    this.applyRightToLeftFormattingIfNeeded(window.current_language)
                    this.loadPollProperties();
                });
            }
        },
        applyRightToLeftFormattingIfNeeded(language) {
            const rightToLeftLanguages = ["ar", "ur"];
            const view = $(".view");

            if (rightToLeftLanguages.includes(language)) {
                view.addClass("right-to-left-formatting");
                return;
            }

            view.removeClass("right-to-left-formatting");
        },
        is_disabled_next: function () {

            // Disable 'next' button if editor is active
            if (this.textEditor.enabled && this.textEditor.active) {
                return true;
            }

            if (this.currentQuestionValid == false) {
                return true;
            }

            const hasAnswerOrCommentOverLimit = this.questions.some(question => this.checkIfMoreThanLimit(question))
            if (hasAnswerOrCommentOverLimit) {
                return true
            }

            const hasCommentButNoAnswer = this.questions.some(question => !question.is_required && this.questionHasCommentButNoAnswer(question))
            if (hasCommentButNoAnswer) {
                return true
            }

            var cn = 0;
            if (typeof this.questions !== 'undefined' && this.questions.length > 0)

                for (var i = this.questions.length - 1; i >= 0; i--) {
                    if (this.questions[i].hidden == false) {
                        if (this.questions[i].is_required) {

                            // For open question to be optional
                            if ((this.isCorrectCharCnt(this.questions[i]) && this.questions[i].answer !== null && this.questions[i].answer.toString().length > 0) || this.questions[i].question_type == 'header_question') {
                                cn++;
                            }
                        } else {
                            cn++;
                        }
                    } else {
                        cn++;
                    }
                }
            return (cn < this.questions.length) && !this.loading;
        },
        scrollToNextQuestion: function () {
            var n = this.getFirstInvalidQuestion();
            var el = jQuery(".poll-container").eq(n);
            el.removeClass("poll-container-trigger-error");

            var offsetTop = Math.abs(document.body.getBoundingClientRect().top) + el[0].getBoundingClientRect().top - this.stickyHeaderHeight;

            setTimeout(function () {
                el.addClass("poll-container-trigger-error");
            }, 10);

            scroll(0, offsetTop);
        },
        load_next_question: function () {

            console.log('this.invalidity', this.invalidity);

            this.showInvalidMessages();

            // #388 Avoids going to the next stop if the animation is in progress.
            if (this.inTransition) {
                return false;
            }
            if (this.is_disabled_next()) {
                this.scrollToNextQuestion();
                return false;
            }

            this.invalidity = {};
            this.warning = {};

            var that = this;

            // Ask user to confirm that he wants to finish the survey.
            if (this.isLastPage()) {

                // Avoid duplicate calls.
                if (!this.question_was_submitted) {
                    this.onSubmitQuestions(function () {
                        that.finishModal = true;
                    });
                } else {
                    this.finishModal = true;
                }
                this.question_was_submitted = true;

                return false;
            } else {
                this.finishModal = false;
            }
            this.comment_open = null;

            this.pollFooterMsg = false;
            this.canPollFooterMsg = true;

            that.inTransition = true;
            setTimeout(async function () {

                let callback = function () {

                    that.database.questions[that.current_page - 1] = that.questions;

                    that.get_current_page();
                    that.get_poll_questions();
                    if (!that.is_preview) {

                        //Last question answered
                        if (that.current_page > that.total_pages) {

                            that.submitPollAsFinished();
                        }
                    }
                }.bind(that);

                // Submit questions if this not a preview.
                const answerSubmitSuccessful = await that.onSubmitQuestions(callback);

                if (answerSubmitSuccessful) {
                    console.log("Go to next question");
                    jQuery(".poll-actual-questions").addClass("poll-intro-animate");

                    setTimeout(function () {
                        that.inTransition = false;
                        jQuery(".poll-actual-questions").removeClass("poll-intro-animate");
                    }, 200);
                } else {
                    that.inTransition = false;
                }
            }, 200);

        },
        get_current_page(state) {

            var that = this;
            if (Object.keys(this.skip_logic).length > 0) {
                that.delete_questions = [];
                let getSkipped = function (page) {

                    //get next question ID
                    var question_id,
                        conditions,
                        questions = that.database.questions[page];
                    if (typeof questions !== 'undefined') {
                        for (var q in questions) {

                            question_id = questions[q].id;
                            that.delete_questions.push(questions[q].id);
                            if (typeof that.skip_logic[question_id] !== 'undefined') {
                                for (var s in that.skip_logic[question_id]) {

                                    conditions = that.skip_logic[question_id][s];
                                    for (var c in conditions) {

                                        for (var a in that.answers) {
                                            var answer = that.answers[a];
                                            switch (answer.type) {
                                                case 'multichoice_checkbox':
                                                    for (var sa in answer.answers) {
                                                        if (conditions[c] == sa) {
                                                            return page + 1;
                                                        }
                                                    }
                                                    break;
                                                case 'slider':
                                                    if (conditions[c] == answer.answers / 10) {
                                                        return page + 1;
                                                    }
                                                    break;
                                                default:
                                                    if (conditions[c] == answer.answers) {
                                                        return page + 1;
                                                    }
                                                    break;
                                            }

                                        }

                                    }
                                }
                            } else {
                                return page + 1;
                            }
                        }

                        return getSkipped(page + 1)
                    } else {
                        return null;
                    }
                }

                var new_page = getSkipped(that.current_page);
                if (new_page != null) {
                    if (typeof state !== 'undefined') {
                        that.filterQuestions(new_page - 1);
                        that.current_page = new_page - 1;
                    } else {
                        jQuery(".poll-actual-questions").addClass("poll-outro-animate");
                        setTimeout(function () {
                            jQuery(".poll-actual-questions").removeClass("poll-outro-animate").addClass("poll-intro-animate");
                        }, 200);
                        that.current_page = new_page;
                        that.filterQuestions();
                    }
                } else {
                    that.finishModal = true;
                }


            } else {
                if (typeof state === 'undefined') {
                    that.current_page += 1;
                }
            }
            if (state == 'start' && this.poll_progress.finished == 0 && this.isLastPage()) {
                that.current_page -= 1;
            }

        },
        filterQuestions(page) {
            var that = this;
            that.skipped_questions = 0;
            if (!that.current_page) return

            const questions = that.database.questions[page ? page : that.current_page - 1]
            const routingQuestions = questions.filter(({id: questionId}) => Object.keys(that.skip_logic).includes(JSON.stringify(questionId)))
            questions.forEach(({ id: questionId }, questionIndex) => {
                let found = false;
                const hasRouting = routingQuestions.some(q => q.id === questionId)

                if (!hasRouting) return

                const questionIdsThatDictateCurrent = Object.keys(that.skip_logic[questionId])
                questionIdsThatDictateCurrent.forEach(qId => {
                    that.skip_logic[questionId][qId].forEach(answerIdToCheck => {
                        Object.keys(that.answers).forEach(answerKey => {
                            if (this.checkIfFoundAndHidden(that.answers[answerKey], answerIdToCheck)) {
                                found = true
                                questions[questionIndex].hidden = false;
                            }
                        })
                    })
                })

                if (!found) {
                    that.skipped_questions += 1;
                    questions[questionIndex].hidden = true;
                    switch (questions[questionIndex].question_type) {
                        case 'multichoice_checkbox':
                        case 'multichoice_radio':
                            questions[questionIndex].answer = [];
                            break;
                        default:
                            questions[questionIndex].answer = null;
                            break;
                    }
                }
            })
        },

        checkIfFoundAndHidden(answer, answerIdToCheck) {
            switch (answer.type) {
                case 'multichoice_checkbox':
                    return Object.keys(answer.answers).some(answerId => answerId == answerIdToCheck)
                case 'slider':
                    return answerIdToCheck == answer.answers / 10
                default:
                    return answerIdToCheck == answer.answers
            }
        },

        getPreviousPage() {
            if (this.isSkipLogicEnabled()) {
                const skipLogicService = new SkipLogicService(this);
                this.current_page = skipLogicService.getPreviousPage(this.current_page - 1);
                this.filterQuestions();
            } else {
                const prevPageQuestions = this.database.questions[this.current_page - 2];
                this.clearAndAddQuestionsToDelete(prevPageQuestions);
                this.current_page -= 1;
            }
        },

        isSkipLogicEnabled() {
            return Object.keys(this.skip_logic).length > 0;
        },

        deleteQuestions(questionId) {
            this.delete_questions.push(questionId);
            delete this.answers[questionId];
        },

        clearAndAddQuestionsToDelete(questions) {
            this.delete_questions = [];
            for (let q in questions) {
                this.deleteQuestions(questions[q].id)
            }
        },
        submitPollAsFinished() {

            console.log('submitPollAsFinished');

            // Wait for all question requests to be completed(or timeout).

            if (this.is_preview || this.previewUser) {
                this.current_page = Object.keys(this.database.questions).length + 1;
                this.database.questions[this.current_page - 1] = this.questions;
                this.get_poll_questions();
                this.finishModal = false;
            } else {

                const intervalRate = 500; //ms
                const interval = setInterval(() => {
                    if (this.outstandingRequestCount) {
                        console.log('waiting for requests, ', this.outstandingRequestCount);
                        return;
                    }

                    const closePromise = closeSurvey({
                        targetId: this.poll_id,
                        responseId: this.responseId,
                        body: { validation: this.validationToken },
                    }, this.poll_info.survey_type)

                    clearInterval(interval);

                    // Mark survey as finished.
                    closePromise.then(() => {

                        window.onbeforeunload = null;
                        // Switch to the next page.
                        this.database.questions[this.current_page - 1] = this.questions;

                        this.current_page += 1;
                        this.get_poll_questions();

                        // Hide the confirm modal.
                        this.finishModal = false;

                        //Redirect to dashboard
                        if (this.poll_info.survey_type == 'parent') {
                            this.$http.get('/reset-session').then(function onSuccess(response) {
                                console.log('reset session');
                            });

                            try {
                                this.$http.get('logout').then(function onSuccess(response) {
                                    console.log('api logout');
                                }, error => {
                                    console.log('error caught, might not require a logout')
                                })
                            } catch (e) {
                                console.log('error caught, might not require a logout')
                            }
                        }
                    });
                }, intervalRate);
            }
        },

        async onSubmitQuestions(callback) {
            console.log('onSubmitQuestions');

            //Prepare data
            var question_ids = [];
            var question_group_indexes = {};
            var question_types = {};
            var qtip_clicked = {};
            var answers = {};
            var sliders = {};
            var comment = {};
            var answer_comments = {};
            var that = this;

            // patch undefined poll_id request
            if (typeof this.poll_id === 'undefined') {
                await this.loadPollProperties();

                // if error.msg is not empty survey doesn't exist or is finished
                if (this.error.msg !== '') {
                    return;
                }
            }


            for (var index = 0; index < this.questions.length; index++) {
                var question = this.questions[index];

                question_ids.push(question.id);

                question_group_indexes[question.id] = question.group_index;
                question_types[question.id] = question.question_type;

                if (typeof question.qtip !== 'undefined' && question.qtip) {

                    qtip_clicked[question.id] = true;
                } else {

                    qtip_clicked[question.id] = false;
                }

                // Collect answers.
                if (typeof question.answer !== 'undefined' && question.answer !== null) {

                    if (question.question_type === 'multichoice_radio' && question.answer.length > 0) {

                        // #372 Do not pop the answer, just read it.
                        answers[question.id] = question.answer[question.answer.length - 1];
                    } else if (question.question_type === 'multichoice_checkbox') {
                        answers[question.id] = {};

                        console.log(question.answer);

                        for (var answer_index in question.answer) {
                            console.log(answer_index);
                            console.log(question.answer[answer_index]);
                            answers[question.id][question.answer[answer_index]] = true;
                        }
                    } else {

                        answers[question.id] = question.answer;
                    }
                } else {

                    answers[question.id] = null;
                }

                that.answers[question.id] = { answers: answers[question.id],
                    type: question.question_type };
                this.collectAnswerComments(answer_comments, question, answers);
                comment[question.id] = question.comment;
            }

            var data = {
                session_id: this.session_id,
                question_id: question_ids,
                question_group_index: question_group_indexes,
                question_type: question_types,
                qtip_clicked: qtip_clicked,
                answer: answers,
                slider: sliders,
                comment: comment,
                skipped_questions: that.skipped_questions,
                answer_comments: answer_comments,
                page: this.current_page,
                start_time: this.question_start,
                finish_time: this.get_time(),
                platform: 'web',
                uid: this.poll_progress.uid,
            };

            if (this.group_id) data.group_id = this.group_id;

            //Submit data
            if (!that.is_preview && !this.previewUser) {
                const body = {
                    questions: getSubmitQuestionsBody(this.questions),
                    validation: this.validationToken,
                }

                if (body.questions.length > 0) {
                    const promise = submitQuestions({
                        targetId: this.poll_id,
                        responseId: this.responseId,
                        body
                    }, this.poll_info.survey_type);

                    this.outstandingRequestCount += 1;

                    await promise.then(response => {
                        console.log('answer submit success');
                        this.answerSavingSuccessful = true;
                        for (const question of data.question_id) {
                            this.question_hash[question] = {
                                hash: response.body.hash,
                                answer: answers
                            };
                        }
                        this.outstandingRequestCount -= 1;
                    }, error => {
                        this.handleFailedAnswerSave();

                        console.error('answer submit error', error);
                        this.outstandingRequestCount -= 1;

                        if (this.errorStatusCodes.indexOf(error.status) > -1) {
                            this.unsavedData.push(body);
                        }
                    });
                }
            }

            if (this.answerSavingSuccessful === true) {
                callback();
            }

            return this.answerSavingSuccessful;
        },

        collectAnswerComments(answer_comments, question, answers) {

            // Collect comments from answers. Check if the question has any comment.
            if (typeof question.ans_comment !== 'undefined' && question.ans_comment !== null) {

                switch (question.question_type) {

                    case 'multichoice_radio':
                        let answerId = answers[question.id];

                        if (typeof question.ans_comment[answerId] !== 'undefined' && question.ans_comment[answerId] !== null) {
                            answer_comments[answerId] = question.ans_comment[answerId];
                        }
                        break;
                    case 'multichoice_checkbox':

                        // Traverse each answer and check if it has a comment attached.
                        for (let answerId in answers[question.id]) {

                            if (typeof question.ans_comment[answerId] !== 'undefined' && question.ans_comment[answerId] !== null) {
                                answer_comments[answerId] = question.ans_comment[answerId];
                            }
                        }
                        break;
                }
            }
        },

        load_prev_question: function () {
            // Disable 'previous' button if editor is active
            if (this.textEditor.enabled && this.textEditor.active) {
                return false;
            }

            this.invalidity = {};
            this.warning = {};
            this.currentQuestionValid = true;//trust me! it was

            var that = this;
            this.getPreviousPage();
            this.comment_open = null;
            if (that.current_page == 0) {
                that.poll_info.welcome = true;
            } else {
                jQuery(".poll-actual-questions").addClass("poll-outro-animate-back");
                console.log("Go to next question");

                that.inTransition = true;
                setTimeout(function () {
                    jQuery(".poll-actual-questions").removeClass("poll-outro-animate-back").addClass("poll-intro-animate-back");

                    that.get_poll_questions();
                    setTimeout(function () {
                        that.inTransition = false;
                        jQuery(".poll-actual-questions").removeClass("poll-intro-animate-back");
                    }, 200);
                }, 200);
            }
        },
        get_poll_questions: function (questions) {
            this.question_start = this.get_time();
            this.loading = true;
            var that = this;
            that.skipped_questions = 0;
            scroll(0, 0);

            if (typeof that.database.questions[that.current_page - 1] === 'undefined') return false;
            that.questions = that.database.questions[that.current_page - 1];

            for (let index in that.questions) {
                if (that.questions[index].question_type === "multichoice_checkbox") {
                    console.log('TRIGGER VALIDATION')
                    this.validateMultiCheckbox(index, 0);

                    if (typeof this.invalidity[index] !== 'undefined' && Object.keys(this.invalidity[index]).length > 0) {
                        console.log("THIS IS SO INVALID")
                        this.currentQuestionValid = false;
                    } else {
                        console.log("VALID")
                        this.currentQuestionValid = true;
                    }
                }
            }

//            for(var key in that.questions){
//                if(typeof questions !== 'undefined') {
//                    if ($.inArray(that.questions[key].id, questions) === -1) {
//                        that.questions[key].hidden = true;
//                        that.skipped_questions += 1;
//                    } else {
//                        that.questions[key].hidden = false;
//                    }
//                }else{
//                    that.questions[key].hidden = false;
//                }
//            }
            that.loading = false;


            that.$nextTick(function () {
                that.reloadStickyFooter();

                setTimeout(function () {
                    jQuery.each(jQuery('textarea[data-autoresize]'), function () {
                        var offset = this.offsetHeight - this.clientHeight;

                        var resizeTextarea = function (el) {
                            jQuery(el).css('height', 'auto').css('height', el.scrollHeight + offset);
                        };
                        jQuery(this).on('keyup input', function () {
                            resizeTextarea(this);
                        }).removeAttr('data-autoresize');

                        jQuery(window).trigger('edurio:pageload');
                    });
                }, 300);
            });
        },
        multiRadioChange: function (index, item) {
            this.questions[index].answer = Object.assign([item.value]);
            // Scroll to the next question
            // this.scrollToNextQuestion();
        },
        multiCheckboxChange: function (index, item) {

            if (this.questions[index].answer == null) this.questions[index].answer = [];

            const num = this.questions[index].answer.indexOf(item.value);
            if (num > -1) {
                this.questions[index].answer.splice(num, 1);
            } else {
                var that = this;
                if (this.canPollFooterMsg) {
                    this.pollFooterMsg = true;
                    this.canPollFooterMsg = false;
                    setTimeout(function () {
                        that.pollFooterMsg = false;
                    }, 5000);
                }
                this.questions[index].answer.push(item.value);
            }

            this.validateMultiCheckbox(index, item);

            if (typeof this.invalidity[index] !== 'undefined' && Object.keys(this.invalidity[index]).length > 0) {
                this.currentQuestionValid = false;
            } else {
                this.currentQuestionValid = true;
            }

        },
        setOptionsComment(question_index, item) {
            if (this.questions[question_index]) this.questions[question_index].ans_comment[item.value] = item.comment;
        },
        ifChoiseChecked: function (index, item) {
            if (this.questions[index].answer == null) this.questions[index].answer = [];


            return this.questions[index].answer.indexOf(item.value) > -1;
        },
        getFirstInvalidQuestion: function () {
            var cn = false;
            if (typeof this.questions !== 'undefined' && this.questions.length > 0)
                for (var i = this.questions.length - 1; i >= 0; i--) {
                    if (this.questions[i].hidden == false && (this.questions[i].answer === null || this.questions[i].answer.toString().length <= 0) && this.questions[i].question_type !== 'header_question') {
                        cn = i;
                    }
                }
            return cn;
        },

        reloadStickyEl: function (el) {
            var t = el.style.transform;
            if (el && t != "translate(0,0)") {
                var scroll = document.body.scrollTop;
                var v = el.parentElement.getBoundingClientRect();
                var i = window.innerHeight + scroll;
                var k = scroll + v.bottom;
                var n = scroll + v.top;
                if (i > k || i < n) {
                    el.classList.remove("poll-start-survey-absolute");
                    el.style.position = "absolute";
                    el.style.top = "auto";
                    el.style.left = "0px";
                    el.style.bottom = "0px";
                    el.style.width = "100%";
                } else {
                    if ((k - i) > v.height - el.z) {
                        el.classList.remove("poll-start-survey-absolute");
                        el.style.position = "absolute";
                        el.style.left = "0px";
                        el.style.bottom = "auto";
                        el.style.width = "100%";
                    } else {
                        el.classList.add("poll-start-survey-absolute");
                        el.style.transform = "translate3d(0px,0px,0px)";
                        el.style.position = "fixed";
                        el.style.top = "auto";
                        el.style.left = v.left + "px";
                        el.style.bottom = "0px";
                        el.style.width = v.width + "px";
                    }
                }
            }
        },
        reloadStickyQuestion: function (el) {
            if (el) {
                var scroll = document.body.scrollTop;
                var v = el.parentElement.getBoundingClientRect();
                var e = el.getBoundingClientRect();
                var commentEl = jQuery(el).parent().children(".poll-comment");
                var bottomOffset = (commentEl[0]) ? commentEl[0].getBoundingClientRect().height : 0;

                const newTop = (el.classList.contains('title')) ? 0 : this.stickyHeaderHeight;

                if (v.top <= newTop && (el.classList.contains('title') || e.height <= v.bottom + e.height)) {
                    if (e.height + bottomOffset + newTop <= v.bottom || (e.height + bottomOffset + newTop > v.bottom && el.classList.contains('title'))) {
                        jQuery(el).css({
                            'position': 'fixed',
                            'top': newTop + 'px',
                            'bottom': 'auto',
                            'left': v.left + 'px',
                            'width': v.width + 'px',
                        });
                    } else if (!el.classList.contains('title')) {
                        jQuery(el).css({
                            'position': 'absolute',
                            'top': 'auto',
                            'bottom': bottomOffset + 'px',
                            'left': '0px',
                            'width': '100%',
                        });
                    }
                    jQuery(el).addClass("poll-question-is-floating").parent().css({ 'padding-top': e.height + "px" });
                } else {
                    if (el.classList.contains('title') && e.height > v.bottom + e.height) return false;
                    jQuery(el).removeClass("poll-question-is-floating").removeAttr('style').parent().removeAttr('style');
                }
            }
        },
        reloadStickyFooter: function () {
            const item = jQuery(".poll-start-survey")
            if (item.length > 0) {
                this.reloadStickyEl(item[0])
            }

            this.reloadHeaderQuestions()

            const documentHeight = this.getDocumentMaxHeight()

            const windowHeight = this.getWindowMaxHeight()
            const hasScrolledToBottom = (windowHeight + window.scrollY) >= (documentHeight - 10)

            const documentBody = jQuery("body")
            const documentScrollable = "document-is-scrollable"

            const documentIsScrollable = documentHeight > windowHeight && !documentBody.hasClass(documentScrollable)
            const documentIsNotScrollable = documentHeight <= windowHeight && documentBody.hasClass(documentScrollable)

            if (hasScrolledToBottom || documentIsNotScrollable) {
                documentBody.removeClass(documentScrollable)
            } else if (documentIsScrollable) {
                documentBody.addClass(documentScrollable)
            }
        },
        reloadHeaderQuestions() {
            const headers = jQuery(".poll-question.title")
            this.stickyHeaderHeight = (headers.length > 0) ? parseInt(headers[0].getBoundingClientRect().height) : 0
            if (headers.length > 0) {
                for (let i = headers.length - 1; i >= 0; i--) {
                    this.reloadStickyQuestion(headers[i])
                }
            }
        },
        getDocumentMaxHeight() {
            const body = document.body,
                html = document.documentElement

            return Math.max(
                body.scrollHeight,
                body.offsetHeight,
                html.clientHeight,
                html.scrollHeight,
                html.offsetHeight
            )
        },
        getWindowMaxHeight() {
            const innertHeight = window.innerHeight || 0
            return Math.max(
                document.documentElement.clientHeight,
                innerHeight
            )
        },
        keyController: function (e) {
            if (this.isStartingSurvey) return false;

            // console.log(e.keyCode, e.target.tagName.toLowerCase());

            // Prevent any keboard action if editor is active
            if (this.textEditor.enabled && this.textEditor.active) {
                e.preventDefault();
                return false;
            }

            if (!this.loading && /(textarea|input)/.test(e.target.tagName.toLowerCase()) === false) {
                // For choosing the answer with keyboard
                if (typeof e.key !== 'undefined' && /^[a-z0-9]+$/i.test(e.key)) {
                    if (jQuery(".poll-container-focused").find(".answer-type-multiple-choise").size() > 0) {
                        jQuery(".poll-container-focused").find(".answer-type-multiple-choise [data-key-opt='" + e.key.toUpperCase() + "']").click();
                    }
                    if (jQuery(".poll-container-focused-2").find(".answer-type-multiple-choise").size() > 0) {
                        jQuery(".poll-container-focused-2").find(".answer-type-multiple-choise [data-key-opt-2='" + e.key.toUpperCase() + "']").click();
                    }
                }

                // Key enter
                if ((e.keyCode === 13 || e.keyCode === 39)) {
                    if (this.poll_info.welcome) {
                        // Start survey
                        this.start_survey();
                    } else if (!this.onboarding.finished) {
                        // Next onboarding
                        this.onboarding_next();
                    } else {
                        this.load_next_question();
                    }
                    this.keyboardPreferred = true;
                }

                // Key backspace
                if (e.keyCode === 8 || e.keyCode === 37) {
                    if (!this.poll_info.welcome && !this.onboarding.finished) {
                        // Previous onboarding
                        this.onboarding.active = Math.max(this.onboarding.active - 1, 0);
                    } else if (!this.poll_info.welcome && this.onboarding.finished) {
                        this.load_prev_question();
                    }
                    this.keyboardPreferred = true;
                    e.preventDefault();
                }
            }
        },

        questionIndex: function (page, question) {
            var counter = 1;
            var this_q = this.database.questions;
            for (var i = 0; i <= this.database.questions.length - 1; i++) {
                if (page > i) {
                    counter += this.database.questions[i].length;
                    if (this.database.questions[i][0].question_type === 'header_question') {
                        counter = counter - 1;
                    }
                } else if (page == i) {
                    counter += question;
                    if (this.database.questions[i][0].question_type === 'header_question') {
                        counter = counter - 1;
                    }
                }
            }
            return counter;
        },

        pollRatingChoose: function (rate) {
            this.pollRating.rating = rate;

            this.$nextTick(function () {
                jQuery.each(jQuery('textarea[data-autoresize]'), function () {
                    var offset = this.offsetHeight - this.clientHeight;

                    var resizeTextarea = function (el) {
                        jQuery(el).css('height', 'auto').css('height', el.scrollHeight + offset);
                    };
                    jQuery(this).on('keyup input', function () {
                        resizeTextarea(this);
                    }).removeAttr('data-autoresize');
                });
            });
        },
        pollRatingSave: function () {
            if (this.pollRating.rating !== null && this.pollRating.explain !== '') {
                this.pollRating.saved = true;
                console.log("SEND TO API", this.pollRating);
            }
        },
        clickToComment: function (index) {
            this.comment_open = index;
            this.$nextTick(function () {
                jQuery(".comment-textarea-nr-" + index).focus();
            });
        },
        clickHelpTooltip: function (index) {
            this.help_tooltip = (this.help_tooltip == index) ? null : index;

            // Mark that question tip was viewed.
            if (index > -1 && typeof this.questions[index] !== 'undefined') {

                this.questions[index].qtip = 1;
            }
        },
        onboarding_next: function () {
            if (this.onboarding.list.length - 1 > this.onboarding.active) {
                this.onboarding.active++;
            } else {
                this.onboarding.finished = true;
                this.start_survey();
            }
        },

        getVisiblePercentage(clientHeight, thisel) {
            if (typeof thisel[0] === 'undefined') return 0;
            var rect = thisel[0].getBoundingClientRect();
            var t = rect.top,
                b = rect.bottom,
                h = rect.height,
                oh = Math.round(100 / h * Math.max(Math.min(b, clientHeight), 0)),
                oh2 = Math.round(100 / h * Math.max(Math.min(t, clientHeight), 0)),
                p = oh - oh2;
            return p;
        },
        get_time: function () {
            var d = new Date();
            return parseInt(d.getTime() / 1000);
        },
        checkValidNumerals(question) {
            let errors = 0;
            if (!this.isCorrectCharCnt(question)) {
                errors++;
            }

            const onlyNumbers = new RegExp('^[0-9]+$');
            const numeralsValid = question.answer.match(onlyNumbers) !== null;
            if (!numeralsValid) {
                this.displayNumeralAnswerError[question.id] = true;
                errors++;
            } else {
                delete this.displayNumeralAnswerError[question.id];
            }

            const questionsThatShouldBeLookedAt = this.questions.filter(q => q.question_type === "open" && q.display_type === "numerals")
            let valid_field_count = 0;
            for (var i = 0; i < questionsThatShouldBeLookedAt.length; i++) {
                if (questionsThatShouldBeLookedAt[i].answer.match(onlyNumbers) !== null) {
                    valid_field_count++;
                }
            }

            this.currentQuestionValid = valid_field_count == questionsThatShouldBeLookedAt.length;
        },
        isCorrectCharCnt(question) {
            if (question.question_type !== 'open') {
                return true;
            }
            if (this.checkIfMoreThanLimit(question)) {
                return false
            }
            if (typeof question.meta === 'undefined' || question.meta === null) {
                return true;
            }
            if (typeof question.meta.char_limit === 'undefined' || question.meta.char_limit === null) {
                return true;
            }
            let isCorrectMin = this.isCorrectCharCntMin(question);
            let isCorrectMax = this.isCorrectCharCntMax(question);

            return isCorrectMin && isCorrectMax;
        },
        isCorrectCharCntMin(question) {
            // Limit is not set.
            if (typeof question.meta.char_limit.min === 'undefined' || question.meta.char_limit.min === null) {
                return true;
            }
            if (!question.meta.char_limit.min) {
                return true;
            }
            // Answer is shorter than the min required character count.
            if (question.meta.char_limit.min <= question.answer.length) {
                return true;
            }
            return false;
        },
        isCorrectCharCntMax(question) {
            // Limit is not set.
            if (typeof question.meta.char_limit.max === 'undefined' || question.meta.char_limit.max === null) {
                return true;
            }
            if (!question.meta.char_limit.max) {
                return true;
            }
            // Answer is longer than the min required character count.
            if (question.meta.char_limit.max >= question.answer.length) {
                return true;
            }
            return false;
        },
        getCharactersLeft(question) {
            return question.meta.char_limit.max - question.answer.length;
        },
        uiInit() {

            var that = this;

            jQuery(window).on("ready scroll resize edurio:pageload", function () {
                var items = jQuery('.poll-container.can-focus-me');
                var clientHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

                items.removeClass('poll-container-focused-2 poll-container-focused');

                var final = items.eq(0);
                var second = false;
                var prc = 0;
                var index = 0;
                var pastFirst = 0;

                items.each(function () {
                    var thisel = jQuery(this);
                    var p = that.getVisiblePercentage(clientHeight, thisel);

                    if (p > prc) {
                        var nextItem = items.eq(index + 1);
                        prc = p;
                        final = thisel;
                        pastFirst = 1;
                    }
                    if (pastFirst === 1) {
                        var p2 = that.getVisiblePercentage(clientHeight, nextItem);
                        if (p2 > 80) {
                            second = nextItem;
                        }
                        pastFirst = 2;
                    }
                    index += 1;
                });
                if (second) {
                    second.removeClass('poll-container-focused').addClass('poll-container-focused-2');
                }
                if (final) {
                    final.removeClass('poll-container-focused-2').addClass('poll-container-focused');
                }
            });

            window.addEventListener('keyup', this.keyController, false);

            this.$watch('poll_info.welcome', function (newVal) {
                if (newVal == false && that.onboarding.active < that.onboarding.list.length - 1 && !that.onboarding.finished) {
                    that.onboarding.width = jQuery(".poll-onboarding")[0].getBoundingClientRect().width;
                    //Enable swiping...
                    jQuery(".poll-onboarding").swipe({
                        swipeStatus: function (event, phase, direction, distance, duration, fingers, fingerData, currentDirection) {
                            if (phase == 'start') {
                                this.find(".slide-wrapper").removeClass('allow-anim');
                            }

                            if (direction == 'left' && that.onboarding.active >= that.onboarding.list.length - 1) {
                                this.css("margin-left", ((-distance)) + "px");
                                console.log(-distance);

                                if (phase == "end") {
                                    var largeitem = this;
                                    this.addClass("allow-anim").css("margin-left", "-100%");
                                    console.log("Go next");
                                    setTimeout(function () {
                                        largeitem.css("margin-left", "0px");
                                        that.onboarding_next();
                                    }, 200);
                                }
                                if (phase == "cancel") {
                                    this.css("margin-left", "0px");
                                    console.log(0);
                                    console.log("Stay in place");
                                }
                            }

                            if (direction == 'left' && that.onboarding.active < that.onboarding.list.length - 1) {
                                this.find(".slide").eq(0).css("margin-left", ((-distance) - ((that.onboarding.active) * that.onboarding.width)) + "px");
                                console.log(-distance);

                                if (phase == "end") {
                                    console.log("Go next");
                                    this.find(".slide-wrapper").addClass('allow-anim');
                                    that.onboarding.active += 1;
                                }
                                if (phase == "cancel") {
                                    this.find(".slide-wrapper").addClass('allow-anim');
                                    this.find(".slide").eq(0).css("margin-left", -((that.onboarding.active) * that.onboarding.width) + "px");
                                    console.log(0);
                                    console.log("Stay in place");
                                }
                            }

                            if (direction == 'right' && that.onboarding.active > 0) {
                                this.find(".slide").eq(0).css("margin-left", ((distance) - ((that.onboarding.active) * that.onboarding.width)) + "px");
                                console.log(distance);

                                if (phase == "end") {
                                    console.log("Go previous");
                                    this.find(".slide-wrapper").addClass('allow-anim');
                                    that.onboarding.active -= 1;
                                }
                                if (phase == "cancel") {
                                    this.find(".slide-wrapper").addClass('allow-anim');
                                    this.find(".slide").eq(0).css("margin-left", -((that.onboarding.active) * that.onboarding.width) + "px");
                                    console.log(0);
                                    console.log("Stay in place");
                                }
                            }
                        },
                        allowPageScroll: 'vertical',
                        threshold: 120,
                        maxTimeThreshold: 5000,
                        fingers: 'all'
                    });
                }
            });

            document.addEventListener("touchend", function () {
                that.reloadStickyFooter();
            }, false);

            document.onscroll = function () {
                if (that.help_tooltip != null) {
                    that.help_tooltip = null;
                }
                that.reloadStickyFooter();
            };

            window.onresize = function () {
                that.reloadStickyFooter();
            };

            this.$nextTick(function () {
                that.reloadStickyFooter();
            });
        },
        handleUnsavedData() {
            const body = this.unsavedData.shift();

            if (!this.is_preview && !this.previewUser) {
                const promise = submitQuestions({
                    targetId: this.poll_id,
                    responseId: this.responseId,
                    body
                }, this.poll_info.survey_type);

                this.outstandingRequestCount += 1;

                promise.then(response => {
                    console.log('answer submit success');
                    this.outstandingRequestCount -= 1;
                    if (this.unsavedData.length > 0) {
                        this.handleUnsavedData();
                    } else {
                        // #1865 Display 'All answers are sent!' for 3 seconds.
                        this.offlineAnswersSent = true;
                        setTimeout(() => this.offlineAnswersSent = false, 3000);
                    }
                }, error =>  {
                    console.error('answer submit error', error);
                    this.outstandingRequestCount -= 1;

                    if (this.errorStatusCodes.indexOf(error.status) > -1) {
                        this.unsavedData.unshift(body);
                    }
                });
            }
        },
        validateMultiCheckbox: function (index, item) {

            if (this.questions[index].meta === null || typeof this.questions[index].meta.char_limit === 'undefined') { // no validation rules
                return true;
            }
            // fix question count
            if (this.questions[index].answer == null) this.questions[index].answer = [];

            const answer_count = this.questions[index].answer.length;

            // validate min count
            if (typeof this.questions[index].meta.char_limit.min !== 'undefined') {
                const min = parseInt(this.questions[index].meta.char_limit.min);
                if (answer_count < min) {
                    this.invalidity[index] = {};
                    this.invalidity[index]['min'] = {
                        has: answer_count,
                        need: min
                    };
                } else {
                    if (typeof this.invalidity[index] !== 'undefined' && typeof this.invalidity[index]['min'] !== 'undefined') {
                        delete this.invalidity[index]['min'];
                    }
                }
            }

            // validate max count
            if (typeof this.questions[index].meta.char_limit.max !== 'undefined') {
                const max = parseInt(this.questions[index].meta.char_limit.max);
                if (answer_count > max) {
                    this.invalidity[index] = {};
                    this.invalidity[index]['max'] = {
                        has: answer_count,
                        allowed: max
                    };
                } else {
                    if (typeof this.invalidity[index] !== 'undefined' && typeof this.invalidity[index]['max'] !== 'undefined') {
                        delete this.invalidity[index]['max'];
                    }
                }
            }

            this.showInvalidMessages();

            // return validated;
        },
        showInvalidMessages: function () {
            this.warning = {};
            for (let i in this.invalidity) {
                if (typeof this.invalidity[i]['min'] !== 'undefined') {
                    this.warning['minimal_requirement'] = this.invalidity[i]['min'];
                }
                if (typeof this.invalidity[i]['max'] !== 'undefined') {
                    this.warning['maximum_allowed'] = this.invalidity[i]['max'];
                }

            }
        }
    },
}
</script>
<style lang="scss">
    @include material-icon-loading;

    .poll-start-survey .start-survey-btn {
        .starting-survey-icon {
            display: none;

            i {
                font-size: 20px;
            }
        }

        &.is-starting-survey {
            position: relative;
            pointer-events: none;

            .starting-survey-icon {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                display: block;
            }

            span {
                opacity: 0;
            }
        }
    }

.view.right-to-left-formatting {
    .poll-container .answer-type-multiple-choise label > span {
        &:before {
            left: auto;
            right: 11px;
        }

        &:after {
            left: 11px;
            right: auto;
        }
    }

    .poll-wrapper {
        direction: rtl;
    }

    .poll-text-block {
        text-align: right;
    }
}

span.retry-countdown {
    padding: 0 7px 0 0;

    @media screen and (max-width: 530px) {
        padding: 0;
        font-size: 15px;
    }
}

.answer-type-open-answer textarea {
    display: block;
}

@media (min-width: 531px) {
    i.material-icons.btn-finish {
        display: none;
    }
}

    .poll-header-title .not-in-class-info {
        margin-top: 8px;
        display: block;
        font-size: 14px;
        text-decoration: underline;
        color: rgb($black-1, .6);
    }
</style>
